import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { IndividualMonitoringDetail } from "../types/Individual";
import { ROUTE } from "../routes";
import { useNavigate } from "react-router-dom";

const fetch = (authHeader: string, individualId: number) => () =>
  axios.get<IndividualMonitoringDetail[]>(
    `${env.verifyServiceUrl}individual/monitoring/${individualId}/activity/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useMonitoringActivityData = (id) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["individual", id], fetch(authHeader, id), {retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
